<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Txt } from '$global/components/Txt';
	interface Props {
		children?: import('svelte').Snippet;
		class?: string;
	}

	let { ...props }: Props = $props();
</script>

<span class={twMerge('rounded-lg bg-gray-900 p-2', props.class)}>
	<Txt variant="label4" class="text-white">{@render props.children?.()}</Txt
	></span
>
